import React, { Dispatch, SetStateAction } from "react";
import NextItem from "../components/NextItem";
import BackButton from "../components/BackButton";
import Navigator from '../components/Navigation';
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { useMetaTags } from '../utils/useMetaTags';
import { hashPasswordsFromEnv } from "../utils/passwordUtils";
import { Wavedivider } from "../components/Wavedivider";
import article3Thumbnail from '../image/articles/article3-1.webp';
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import YouTubeEmbed from "../components/YouTubeEmbed";
import { CalloutLink } from "../components/CalloutLink";
import { QuoteBlock } from "../components/QuoteBlock";

function Book3(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
      const hashedPasswords = hashPasswordsFromEnv(
        process.env.REACT_APP_BOOK2_PASSWORDS
      );
      
      useMetaTags({
        title: 'bookreport - Lynkim',
        description: '몰입',
        image: '/ogimage.png',
      });
      
      return (
        <>
        {/* <ProtectedPage password={hashedPasswords} description="이번 가을에 단풍을 보러 간 곳"> */}
          <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
          <div className='fadeIn '>
            <ArticleTitle
              title={'몰입'}
              titleEn={'Flow'}
              description={<div>인간의 성숙</div>}
              descriptionEn={<div>Human maturity</div>}
              category={'book report'}
              date={'2026.07.09.'}
            //   thumbnail={image2}
        />
          </div>
          <Wavedivider/>
          <div className='articleLayout'>
          <ArticleTextSection
          marginBottom={true}
                
                subTitle={<div>1. 인간의 성숙: 어렸을 때 놀이에서 가졌던 진지함을 다시 발견하는 것</div>}
                subTitleEn={<div>1. Human maturity: rediscovering the seriousness we once had in childhood play — Beyond Good and Evil</div>}
                description={<div>니체는 인간의 정신 발달 단계를 낙타, 사자, 그리고 마지막으로 '어린아이'에 비유했다. 어릴 때 우리는 규칙이나 타인의 시선에 얽매이지 않고, 오직 놀이 자체에 순수하게 몰입한다. 니체가 말하는 진정한 성숙은 나이가 들어버리는 것이 아닌, 사회적 관습과 고정관념을 모두 부수고(사자의 단계), 마침내 어린아이처럼 자기 삶을 하나의 거대한 놀이처럼 순수하게 긍정하고 창조해 나가는 상태가 진짜 성숙이자 철학적 완성이라고 말한다. </div>}
                descriptionEn={<div>Nietzsche compared the stages of the human spirit to the camel, the lion, and finally the "child." As children, we aren't bound by rules or the gaze of others — we simply immerse ourselves purely in play itself. True maturity, for Nietzsche, is not merely growing older. It is to break through every social convention and fixed idea (the stage of the lion), and finally, like a child, to affirm and create one's own life as one great game. That state, he says, is real maturity and philosophical completion.</div>}
            />
          <ArticleTextSection
          marginBottom={true}
                marginTop={true}
                subTitle={<div>2. 괴물과 싸우는 사람은 그 과정에서 괴물이 되지 않도록 조심해야 한다. 네가 오랫동안 심연을 들여다보고 있으면, 심연 또한 네 속을 들여다볼 것이므로.</div>}
                description={<div>악이나 부정적인 것과 격력하게 싸우다보면, 어느새 증오와 폭력에 물들어 내가 싸우던 대상을 닮아가기 쉽다. 외부의 악을 처단한다는 명분 아래에서 스스로가 가진 마음깊은 무의식의  잔인함을 정당화하고 있지는 않은지, 내면을 끊임없이 성찰하고 주체성을 잃지 말아야 한다.</div>}
            />
          <ArticleTextSection
          marginBottom={true}
                marginTop={true}
                subTitle={<div>3. 하루의 3분의 2를 자신을 위해 쓰지 못하는 사람은 노예다.</div>}
                description={<div>내 시간과 에너지를 나만의 창조적인 활동과 성찰에 온전히 쓰지 못한다면 본질적으로 과거의 '노예'와 다를 바 없다</div>}
            />
          <ArticleTextSection
          marginBottom={true}
                marginTop={true}
                subTitle={<div>4. 사랑의 치료법은 여전히 고대로부터 전해 내려오는 근본적인 치료법, 즉 사람을 되돌려주는 것이다.</div>}
                description={<div>사랑에 빠지면 상대방에게 과도한 의미를 부여하고, 그 사람을 내 존재의 전부로 착각하거나 반대로 상대를 소유하려 들기도 한다. 이로 인해 생기는 집착과 상처를 치료하는 유일한 방법은 '그 사람을 있는 그대로의 타인으로 돌려보내고, 나 역시 온전한 나 자신으로 돌아오는 것'이다. 타인에게 의존하던 마음을 버리고 스스로 설 때, 비로소 건강한 삶을 회복할 수 있다.</div>}
            />
          <ArticleTextSection
          marginBottom={true}
                marginTop={true}
                subTitle={<div>5. 금지된 관대함. 세상에는 우리가 상상 속의 존재들에게 사랑과 선함을 베풀도록 허용될 만큼 충분한 사랑과 선함은 없다.</div>}
                description={<div>지금 내 가까이에 있는 소중한 사람들에게 소홀히 하는 것은 낭비이자 기만이다. 내 가까이에서 함께 살아가는 사람들에게 감사함을 더 많이 표현하자.</div>}
            />
            <CalloutLink href="https://product.kyobobook.co.kr/detail/S000220279903" target="_blank">
                몰입 - 이근오 
                </CalloutLink>
          <NextItem to='/book1' nextProjectTitle='롤스의 정의론'/>

          <BackButton/>
          {/* </ProtectedPage> */}
        </div>
        </>
      )
  }
  
  export default Book3;